import { useEffect } from 'react';
import { formatPageTitle } from '../utils/page-title';

export function usePageTitle(...parts: Array<string | null | undefined>): void {
  const filtered = parts.filter((part): part is string => Boolean(part?.trim()));
  const title = formatPageTitle(...filtered);

  useEffect(() => {
    if (filtered.length === 0) {
      return;
    }
    document.title = title;
  }, [title, filtered.length]);
}

export function useProjectPageTitle(
  projectTitle: string | null | undefined,
  ...rest: Array<string | null | undefined>
): void {
  const trimmedProjectTitle = projectTitle?.trim() || null;
  usePageTitle(trimmedProjectTitle, ...(trimmedProjectTitle ? rest : []));
}
